var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiskonEksklusifPlusplus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 49,
    viewBox: "0 0 72 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56 48H16C9.40764 48 5.64458 40.4739 9.6 35.2L29.6 8.53333C32.8 4.26667 39.2 4.26667 42.4 8.53334L62.4 35.2C66.3554 40.4739 62.5924 48 56 48Z",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5662 29.184V31.356L23.6702 31.368V29.196L34.5662 29.184ZM30.2222 35.712H28.0502L28.0382 24.816H30.2102L30.2222 35.712ZM48.324 29.184V31.356L37.428 31.368V29.196L48.324 29.184ZM43.98 35.712H41.808L41.796 24.816H43.968L43.98 35.712Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiskonEksklusifPlusplus);
export default __webpack_public_path__ + "static/media/diskon-eksklusif-plusplus.a41c9b8c50f832843283916a574ee06b.svg";
export { ForwardRef as ReactComponent };